import React from 'react';
import { Card, Title, Text, Stack } from '@mantine/core';

const TermsPage: React.FC = () => {
  return (
    <Stack gap="md">
      <Title order={2}>Haftungsausschluss</Title>
      
      <Card withBorder p="md">
        <Stack gap="md">
          <Title order={4}>Haftung für Inhalte</Title>
          <Text>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit 
            und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir 
            gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
          </Text>
          <Text>
            Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder 
            gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
            rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von 
            Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          </Text>
          <Text>
            Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten 
            Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
            Inhalte umgehend entfernen.
          </Text>
          
          <Title order={4}>Haftung für Links</Title>
          <Text>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </Text>
          <Text>
            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
            Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
          </Text>
          <Text>
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </Text>
        </Stack>
      </Card>
      
      <Card withBorder p="md">
        <Text size="sm" c="dimmed">
          © Galek GmbH<br />
          webdesign: frazo.de
        </Text>
      </Card>
    </Stack>
  );
};

export default TermsPage;
